import http from '@/utils/Http'
import {PaymentType} from "@/model";

const searchState = () => {
    return {
        entries: []
    }
};

const BASE_PATH = '/v1/financial_movements';

const loadEntries = (path) => {
    return new Promise((resolve, reject) => {
        http.get(path)
            .then(({data}) => resolve(data))
            .catch(reject);
    })
};

export default {
    namespaced: true,
    state: {
        search: searchState(),
        payment_types: [],
    },
    getters: {
        search(state) {
            return state.search;
        },
        payment_types: state => state.payment_types,
    },
    mutations: {
        resetSearch(state, defaultValues = {}) {
            state.search = Object.assign({}, searchState(), defaultValues);
        },
        setSearch(state, payload) {
            state.search = payload;
        },
        setPaymentTypes: (state, payload) => state.payment_types = payload
    },
    actions: {
        async filter({commit, state}, path) {
            return new Promise((resolve, reject) => {
                http.get(path)
                    .then(({data}) => {
                        commit('setSearch', Object.assign({}, state.search, data));
                        resolve(data);
                    })
                    .catch(reject);
            })
        },
        async loadMore({}, path) {
            return loadEntries(path);
        },
        async load({commit}, id) {
            return new Promise((resolve, reject) => {
                http.get(`${BASE_PATH}/${id}`)
                    .then(({data}) => resolve(data))
                    .catch(reject);
            })
        },
        async loadPaymentTypes({commit}) {
            return new Promise(async (resolve, reject) => {
                const types = await PaymentType.all();
                if (types) {
                    commit('setPaymentTypes', types);
                    resolve(types);
                }

                http.get(`${BASE_PATH}/load_payment_types`)
                    .then(({data}) => {
                        PaymentType.putAll(data);
                        commit('setPaymentTypes', data);
                        if(!types) resolve(data);
                    })
                    .catch(reject);
            })
        },
        async save({commit}, payload) {
            return new Promise((resolve, reject) => {
                if(payload.id) {
                    http.put(`${BASE_PATH}/${payload.id}`, {financial_movement: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                } else {
                    http.post(BASE_PATH, {financial_movement: payload})
                        .then(({data}) => resolve(data))
                        .catch(err => reject(err));
                }
            })
        },
        async destroy({commit}, id) {
            return new Promise((resolve, reject) => {
                http.delete(`${BASE_PATH}/${id}`)
                    .then(({data}) => {
                        resolve(data);
                    })
                    .catch(reject);
            })
        }
    }
}
